@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(713_652_361)
public val Res.string.settings_no_show_off: StringResource by lazy {
      StringResource("string:settings_no_show_off", "settings_no_show_off", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 299159, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 426779, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 273942, 32),
      ))
    }

@delegate:ResourceContentHash(396_360_449)
public val Res.string.settings_no_slots: StringResource by lazy {
      StringResource("string:settings_no_slots", "settings_no_slots", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 299285, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 426913, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 274020, 49),
      ))
    }

@delegate:ResourceContentHash(-1_499_092_863)
public val Res.string.settings_none: StringResource by lazy {
      StringResource("string:settings_none", "settings_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 299339, 29),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 426999, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 274070, 29),
      ))
    }

@delegate:ResourceContentHash(1_013_155_891)
public val Res.string.settings_open_shift_cost: StringResource by lazy {
      StringResource("string:settings_open_shift_cost", "settings_open_shift_cost", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 300464, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 428632, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 275035, 72),
      ))
    }

@delegate:ResourceContentHash(536_702_708)
public val Res.string.settings_open_shift_cost_automatic: StringResource by lazy {
      StringResource("string:settings_open_shift_cost_automatic", "settings_open_shift_cost_automatic", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 299661, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 427429, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 274324, 54),
      ))
    }

@delegate:ResourceContentHash(1_454_014_849)
public val Res.string.settings_open_shift_cost_automatic_hint: StringResource by lazy {
      StringResource("string:settings_open_shift_cost_automatic_hint", "settings_open_shift_cost_automatic_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 299369, 291),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 427037, 391),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 274100, 223),
      ))
    }

@delegate:ResourceContentHash(20_881_389)
public val Res.string.settings_open_shift_cost_fixed: StringResource by lazy {
      StringResource("string:settings_open_shift_cost_fixed", "settings_open_shift_cost_fixed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 299797, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 427601, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 274448, 54),
      ))
    }

@delegate:ResourceContentHash(1_190_725_676)
public val Res.string.settings_open_shift_cost_fixed_value: StringResource by lazy {
      StringResource("string:settings_open_shift_cost_fixed_value", "settings_open_shift_cost_fixed_value", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 299724, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 427504, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 274379, 68),
      ))
    }

@delegate:ResourceContentHash(-315_851_816)
public val Res.string.settings_open_shift_cost_hint: StringResource by lazy {
      StringResource("string:settings_open_shift_cost_hint", "settings_open_shift_cost_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 299856, 349),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 427684, 589),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 274503, 293),
      ))
    }

@delegate:ResourceContentHash(1_462_499_765)
public val Res.string.settings_open_shift_cost_invalid: StringResource by lazy {
      StringResource("string:settings_open_shift_cost_invalid", "settings_open_shift_cost_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 300206, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 428274, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 274797, 76),
      ))
    }

@delegate:ResourceContentHash(1_471_115_712)
public val Res.string.settings_open_shift_cost_rate: StringResource by lazy {
      StringResource("string:settings_open_shift_cost_rate", "settings_open_shift_cost_rate", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 300402, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 428546, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 274977, 57),
      ))
    }

@delegate:ResourceContentHash(-1_724_099_229)
public val Res.string.settings_open_shift_cost_rate_optional: StringResource by lazy {
      StringResource("string:settings_open_shift_cost_rate_optional", "settings_open_shift_cost_rate_optional", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 300287, 114),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 428383, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 274874, 102),
      ))
    }

@delegate:ResourceContentHash(-254_241_694)
public val Res.string.settings_owner_unpaid: StringResource by lazy {
      StringResource("string:settings_owner_unpaid", "settings_owner_unpaid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 300736, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 429056, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 275259, 65),
      ))
    }

@delegate:ResourceContentHash(1_749_071_027)
public val Res.string.settings_owner_unpaid_hint: StringResource by lazy {
      StringResource("string:settings_owner_unpaid_hint", "settings_owner_unpaid_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 300537, 198),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 428725, 330),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 275108, 150),
      ))
    }

@delegate:ResourceContentHash(-269_457_148)
public val Res.string.settings_payroll: StringResource by lazy {
      StringResource("string:settings_payroll", "settings_payroll", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 300818, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 429150, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 275325, 48),
      ))
    }

@delegate:ResourceContentHash(-559_455_027)
public val Res.string.settings_policy_a_desc: StringResource by lazy {
      StringResource("string:settings_policy_a_desc", "settings_policy_a_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 300871, 110),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 429243, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 275374, 106),
      ))
    }

@delegate:ResourceContentHash(-676_668_212)
public val Res.string.settings_policy_a_title: StringResource by lazy {
      StringResource("string:settings_policy_a_title", "settings_policy_a_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 300982, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 429406, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 275481, 71),
      ))
    }

@delegate:ResourceContentHash(575_955_248)
public val Res.string.settings_policy_b_desc: StringResource by lazy {
      StringResource("string:settings_policy_b_desc", "settings_policy_b_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 301050, 118),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 429490, 190),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 275553, 114),
      ))
    }

@delegate:ResourceContentHash(-1_374_690_291)
public val Res.string.settings_policy_b_title: StringResource by lazy {
      StringResource("string:settings_policy_b_title", "settings_policy_b_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 301169, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 429681, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 275668, 75),
      ))
    }

@delegate:ResourceContentHash(-1_273_971_655)
public val Res.string.settings_policy_c_desc: StringResource by lazy {
      StringResource("string:settings_policy_c_desc", "settings_policy_c_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 301249, 142),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 429785, 210),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 275744, 138),
      ))
    }

@delegate:ResourceContentHash(1_970_235_236)
public val Res.string.settings_policy_c_title: StringResource by lazy {
      StringResource("string:settings_policy_c_title", "settings_policy_c_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 301392, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 429996, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 275883, 83),
      ))
    }

@delegate:ResourceContentHash(1_671_948_897)
public val Res.string.settings_policy_d_desc: StringResource by lazy {
      StringResource("string:settings_policy_d_desc", "settings_policy_d_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 301476, 114),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 430108, 174),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 275967, 122),
      ))
    }

@delegate:ResourceContentHash(1_553_146_741)
public val Res.string.settings_policy_d_title: StringResource by lazy {
      StringResource("string:settings_policy_d_title", "settings_policy_d_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 301591, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 430283, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 276090, 79),
      ))
    }

@delegate:ResourceContentHash(800_076_651)
public val Res.string.settings_policy_updated: StringResource by lazy {
      StringResource("string:settings_policy_updated", "settings_policy_updated", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 301675, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 430403, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 276170, 59),
      ))
    }

@delegate:ResourceContentHash(-377_501_387)
public val Res.string.settings_remove_workspace: StringResource by lazy {
      StringResource("string:settings_remove_workspace", "settings_remove_workspace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 302397, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 431617, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 276804, 57),
      ))
    }

@delegate:ResourceContentHash(1_316_793_403)
public val Res.string.settings_remove_workspace_confirm: StringResource by lazy {
      StringResource("string:settings_remove_workspace_confirm", "settings_remove_workspace_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 301747, 649),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 430495, 1121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 276230, 573),
      ))
    }

@delegate:ResourceContentHash(-737_411_234)
public val Res.string.settings_reports_hint: StringResource by lazy {
      StringResource("string:settings_reports_hint", "settings_reports_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 302447, 177),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 431691, 281),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 276862, 181),
      ))
    }

@delegate:ResourceContentHash(114_882_848)
public val Res.string.settings_reports_title: StringResource by lazy {
      StringResource("string:settings_reports_title", "settings_reports_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 302625, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 431973, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 277044, 42),
      ))
    }

@delegate:ResourceContentHash(1_199_798_598)
public val Res.string.settings_request_types: StringResource by lazy {
      StringResource("string:settings_request_types", "settings_request_types", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 302668, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 432020, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 277087, 50),
      ))
    }

@delegate:ResourceContentHash(1_806_165_867)
public val Res.string.settings_requests: StringResource by lazy {
      StringResource("string:settings_requests", "settings_requests", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 302830, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 432210, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 277241, 37),
      ))
    }

@delegate:ResourceContentHash(2_098_589_596)
public val Res.string.settings_requests_days: StringResource by lazy {
      StringResource("string:settings_requests_days", "settings_requests_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 302723, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 432075, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 277138, 50),
      ))
    }

@delegate:ResourceContentHash(1_748_217_082)
public val Res.string.settings_requests_hours: StringResource by lazy {
      StringResource("string:settings_requests_hours", "settings_requests_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 302774, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 432138, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 277189, 51),
      ))
    }

@delegate:ResourceContentHash(1_723_839_312)
public val Res.string.settings_rest_rules: StringResource by lazy {
      StringResource("string:settings_rest_rules", "settings_rest_rules", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 303729, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 433761, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 278088, 51),
      ))
    }

@delegate:ResourceContentHash(-1_411_166_930)
public val Res.string.settings_rest_rules_hint: StringResource by lazy {
      StringResource("string:settings_rest_rules_hint", "settings_rest_rules_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 302868, 572),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 432252, 1092),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 277279, 528),
      ))
    }

@delegate:ResourceContentHash(-687_251_091)
public val Res.string.settings_rest_rules_off: StringResource by lazy {
      StringResource("string:settings_rest_rules_off", "settings_rest_rules_off", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 303441, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 433345, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 277808, 67),
      ))
    }

@delegate:ResourceContentHash(-895_889_477)
public val Res.string.settings_rest_rules_on: StringResource by lazy {
      StringResource("string:settings_rest_rules_on", "settings_rest_rules_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 303501, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 433433, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 277876, 50),
      ))
    }

@delegate:ResourceContentHash(-1_021_420_522)
public val Res.string.settings_rest_rules_switch: StringResource by lazy {
      StringResource("string:settings_rest_rules_switch", "settings_rest_rules_switch", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 303552, 106),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 433496, 174),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 277927, 98),
      ))
    }

@delegate:ResourceContentHash(337_086_377)
public val Res.string.settings_rest_rules_title: StringResource by lazy {
      StringResource("string:settings_rest_rules_title", "settings_rest_rules_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 303659, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 433671, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 278026, 61),
      ))
    }

@delegate:ResourceContentHash(790_172_510)
public val Res.string.settings_role_hint: StringResource by lazy {
      StringResource("string:settings_role_hint", "settings_role_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 303793, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 433849, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 278140, 54),
      ))
    }

@delegate:ResourceContentHash(-2_135_110_941)
public val Res.string.settings_roles: StringResource by lazy {
      StringResource("string:settings_roles", "settings_roles", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 303864, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 433948, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 278195, 30),
      ))
    }

@delegate:ResourceContentHash(-895_124_109)
public val Res.string.settings_roster_blueprint: StringResource by lazy {
      StringResource("string:settings_roster_blueprint", "settings_roster_blueprint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 304006, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 434150, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 278349, 57),
      ))
    }

@delegate:ResourceContentHash(-1_038_473_810)
public val Res.string.settings_roster_blueprint_desc: StringResource by lazy {
      StringResource("string:settings_roster_blueprint_desc", "settings_roster_blueprint_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 303903, 102),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 433987, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 278226, 122),
      ))
    }

@delegate:ResourceContentHash(1_716_695_914)
public val Res.string.settings_roster_visibility: StringResource by lazy {
      StringResource("string:settings_roster_visibility", "settings_roster_visibility", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 305181, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 435753, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 279532, 62),
      ))
    }

@delegate:ResourceContentHash(-1_972_230_880)
public val Res.string.settings_roster_visibility_full: StringResource by lazy {
      StringResource("string:settings_roster_visibility_full", "settings_roster_visibility_full", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 304157, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 434341, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 278504, 63),
      ))
    }

@delegate:ResourceContentHash(-271_429_482)
public val Res.string.settings_roster_visibility_full_desc: StringResource by lazy {
      StringResource("string:settings_roster_visibility_full_desc", "settings_roster_visibility_full_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 304060, 96),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 434220, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 278407, 96),
      ))
    }

@delegate:ResourceContentHash(-1_404_758_505)
public val Res.string.settings_roster_visibility_hidden_people: StringResource by lazy {
      StringResource("string:settings_roster_visibility_hidden_people", "settings_roster_visibility_hidden_people", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 304213, 160),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 434413, 240),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 278568, 156),
      ))
    }

@delegate:ResourceContentHash(538_373_273)
public val Res.string.settings_roster_visibility_hint: StringResource by lazy {
      StringResource("string:settings_roster_visibility_hint", "settings_roster_visibility_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 304374, 187),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 434654, 259),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 278725, 175),
      ))
    }

@delegate:ResourceContentHash(-1_847_414_687)
public val Res.string.settings_roster_visibility_own: StringResource by lazy {
      StringResource("string:settings_roster_visibility_own", "settings_roster_visibility_own", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 304734, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 435146, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 279081, 66),
      ))
    }

@delegate:ResourceContentHash(-1_733_886_963)
public val Res.string.settings_roster_visibility_own_desc: StringResource by lazy {
      StringResource("string:settings_roster_visibility_own_desc", "settings_roster_visibility_own_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 304562, 171),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 434914, 231),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 278901, 179),
      ))
    }

@delegate:ResourceContentHash(516_067_144)
public val Res.string.settings_roster_visibility_title: StringResource by lazy {
      StringResource("string:settings_roster_visibility_title", "settings_roster_visibility_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 304801, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 435229, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 279148, 84),
      ))
    }

@delegate:ResourceContentHash(968_937_062)
public val Res.string.settings_roster_visibility_with_me: StringResource by lazy {
      StringResource("string:settings_roster_visibility_with_me", "settings_roster_visibility_with_me", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 305102, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 435650, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 279457, 74),
      ))
    }

@delegate:ResourceContentHash(1_624_342_183)
public val Res.string.settings_roster_visibility_with_me_desc: StringResource by lazy {
      StringResource("string:settings_roster_visibility_with_me_desc", "settings_roster_visibility_with_me_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 304882, 219),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 435346, 303),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 279233, 223),
      ))
    }

@delegate:ResourceContentHash(-87_353_807)
public val Res.string.settings_sales_targets: StringResource by lazy {
      StringResource("string:settings_sales_targets", "settings_sales_targets", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 305252, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 435816, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 279595, 58),
      ))
    }

@delegate:ResourceContentHash(-1_303_438_526)
public val Res.string.settings_saved: StringResource by lazy {
      StringResource("string:settings_saved", "settings_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 305315, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 435899, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 279654, 42),
      ))
    }

@delegate:ResourceContentHash(-20_392_016)
public val Res.string.settings_section_alerts: StringResource by lazy {
      StringResource("string:settings_section_alerts", "settings_section_alerts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 305362, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 435962, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 279697, 39),
      ))
    }

@delegate:ResourceContentHash(-209_391_861)
public val Res.string.settings_section_availability_slots: StringResource by lazy {
      StringResource("string:settings_section_availability_slots", "settings_section_availability_slots", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 305414, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 436022, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 279737, 67),
      ))
    }

@delegate:ResourceContentHash(-1_979_998_326)
public val Res.string.settings_section_breaks: StringResource by lazy {
      StringResource("string:settings_section_breaks", "settings_section_breaks", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 305486, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 436094, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 279805, 39),
      ))
    }

@delegate:ResourceContentHash(-80_892_344)
public val Res.string.settings_section_clock_review: StringResource by lazy {
      StringResource("string:settings_section_clock_review", "settings_section_clock_review", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 305530, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 436146, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 279845, 57),
      ))
    }

@delegate:ResourceContentHash(231_436_347)
public val Res.string.settings_section_footer: StringResource by lazy {
      StringResource("string:settings_section_footer", "settings_section_footer", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 305596, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 436240, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 279903, 51),
      ))
    }

@delegate:ResourceContentHash(607_967_742)
public val Res.string.settings_section_geofence: StringResource by lazy {
      StringResource("string:settings_section_geofence", "settings_section_geofence", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 305648, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 436300, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 279955, 57),
      ))
    }

@delegate:ResourceContentHash(537_887_796)
public val Res.string.settings_section_income: StringResource by lazy {
      StringResource("string:settings_section_income", "settings_section_income", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 305730, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 436422, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 280013, 39),
      ))
    }

@delegate:ResourceContentHash(1_959_433_535)
public val Res.string.settings_section_labour_targets: StringResource by lazy {
      StringResource("string:settings_section_labour_targets", "settings_section_labour_targets", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 305774, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 436470, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 280053, 67),
      ))
    }

@delegate:ResourceContentHash(-1_197_479_420)
public val Res.string.settings_section_payroll: StringResource by lazy {
      StringResource("string:settings_section_payroll", "settings_section_payroll", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 305838, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 436558, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 280121, 56),
      ))
    }

@delegate:ResourceContentHash(858_713_417)
public val Res.string.settings_section_region: StringResource by lazy {
      StringResource("string:settings_section_region", "settings_section_region", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 305899, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 436647, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 280178, 71),
      ))
    }

@delegate:ResourceContentHash(114_882_848)
public val Res.string.settings_section_reports: StringResource by lazy {
      StringResource("string:settings_section_reports", "settings_section_reports", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 305975, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 436755, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 280250, 44),
      ))
    }

@delegate:ResourceContentHash(1_806_165_867)
public val Res.string.settings_section_requests: StringResource by lazy {
      StringResource("string:settings_section_requests", "settings_section_requests", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 306020, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 436804, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 280295, 45),
      ))
    }

@delegate:ResourceContentHash(337_086_377)
public val Res.string.settings_section_rest_rules: StringResource by lazy {
      StringResource("string:settings_section_rest_rules", "settings_section_rest_rules", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 306066, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 436854, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 280341, 63),
      ))
    }

@delegate:ResourceContentHash(-1_124_035_183)
public val Res.string.settings_section_roles_skills: StringResource by lazy {
      StringResource("string:settings_section_roles_skills", "settings_section_roles_skills", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 306138, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 436946, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 280405, 65),
      ))
    }

@delegate:ResourceContentHash(516_067_144)
public val Res.string.settings_section_roster_visibility: StringResource by lazy {
      StringResource("string:settings_section_roster_visibility", "settings_section_roster_visibility", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 306212, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 437028, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 280471, 86),
      ))
    }

@delegate:ResourceContentHash(1_238_063_429)
public val Res.string.settings_section_sales_targets: StringResource by lazy {
      StringResource("string:settings_section_sales_targets", "settings_section_sales_targets", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 306295, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 437147, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 280558, 58),
      ))
    }

@delegate:ResourceContentHash(954_622_838)
public val Res.string.settings_section_special_days: StringResource by lazy {
      StringResource("string:settings_section_special_days", "settings_section_special_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 306354, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 437222, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 280617, 81),
      ))
    }

@delegate:ResourceContentHash(-1_556_776_153)
public val Res.string.settings_section_staff_checks: StringResource by lazy {
      StringResource("string:settings_section_staff_checks", "settings_section_staff_checks", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 306436, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 437324, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 280699, 65),
      ))
    }

@delegate:ResourceContentHash(-2_015_252_507)
public val Res.string.settings_section_sundays: StringResource by lazy {
      StringResource("string:settings_section_sundays", "settings_section_sundays", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 306494, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 437410, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 280765, 68),
      ))
    }

@delegate:ResourceContentHash(-1_035_551_800)
public val Res.string.settings_section_swap_policy: StringResource by lazy {
      StringResource("string:settings_section_swap_policy", "settings_section_swap_policy", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 306555, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 437499, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 280834, 52),
      ))
    }

@delegate:ResourceContentHash(1_165_924_506)
public val Res.string.settings_section_templates: StringResource by lazy {
      StringResource("string:settings_section_templates", "settings_section_templates", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 306612, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 437572, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 280887, 74),
      ))
    }

@delegate:ResourceContentHash(1_541_822_033)
public val Res.string.settings_section_weather: StringResource by lazy {
      StringResource("string:settings_section_weather", "settings_section_weather", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 306687, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 437675, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 280962, 44),
      ))
    }

@delegate:ResourceContentHash(-1_256_997_613)
public val Res.string.settings_section_work_hours: StringResource by lazy {
      StringResource("string:settings_section_work_hours", "settings_section_work_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 306728, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 437724, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 281007, 51),
      ))
    }

@delegate:ResourceContentHash(-1_253_675_748)
public val Res.string.settings_settlement_months_1: StringResource by lazy {
      StringResource("string:settings_settlement_months_1", "settings_settlement_months_1", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 306784, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 437796, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 281059, 48),
      ))
    }

@delegate:ResourceContentHash(1_403_911_437)
public val Res.string.settings_settlement_months_2: StringResource by lazy {
      StringResource("string:settings_settlement_months_2", "settings_settlement_months_2", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 306837, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 437853, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 281108, 48),
      ))
    }

@delegate:ResourceContentHash(649_359_133)
public val Res.string.settings_settlement_months_3: StringResource by lazy {
      StringResource("string:settings_settlement_months_3", "settings_settlement_months_3", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 306890, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 437910, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 281157, 48),
      ))
    }

@delegate:ResourceContentHash(-1_218_761_946)
public val Res.string.settings_settlement_months_4: StringResource by lazy {
      StringResource("string:settings_settlement_months_4", "settings_settlement_months_4", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 306943, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 437967, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 281206, 48),
      ))
    }

@delegate:ResourceContentHash(586_931_809)
public val Res.string.settings_settlement_period: StringResource by lazy {
      StringResource("string:settings_settlement_period", "settings_settlement_period", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 307252, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 438440, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 281479, 58),
      ))
    }

@delegate:ResourceContentHash(-1_668_884_575)
public val Res.string.settings_settlement_period_hint: StringResource by lazy {
      StringResource("string:settings_settlement_period_hint", "settings_settlement_period_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 306996, 255),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 438024, 415),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 281255, 223),
      ))
    }

@delegate:ResourceContentHash(-341_539_429)
public val Res.string.settings_show_on_map: StringResource by lazy {
      StringResource("string:settings_show_on_map", "settings_show_on_map", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 307315, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 438527, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 281538, 44),
      ))
    }

@delegate:ResourceContentHash(-407_221_780)
public val Res.string.settings_skill_hint: StringResource by lazy {
      StringResource("string:settings_skill_hint", "settings_skill_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 307364, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 438600, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 281583, 51),
      ))
    }

@delegate:ResourceContentHash(-1_791_205_785)
public val Res.string.settings_skills: StringResource by lazy {
      StringResource("string:settings_skills", "settings_skills", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 307436, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 438700, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 281635, 31),
      ))
    }

@delegate:ResourceContentHash(-1_349_106_240)
public val Res.string.settings_slot_end_hint: StringResource by lazy {
      StringResource("string:settings_slot_end_hint", "settings_slot_end_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 307480, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 438744, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 281667, 34),
      ))
    }

@delegate:ResourceContentHash(-415_278_903)
public val Res.string.settings_slot_label_hint: StringResource by lazy {
      StringResource("string:settings_slot_label_hint", "settings_slot_label_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 307519, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 438791, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 281702, 60),
      ))
    }

@delegate:ResourceContentHash(113_466_414)
public val Res.string.settings_slot_label_required: StringResource by lazy {
      StringResource("string:settings_slot_label_required", "settings_slot_label_required", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 307596, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 438884, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 281763, 64),
      ))
    }

@delegate:ResourceContentHash(-1_750_438_827)
public val Res.string.settings_slot_start_hint: StringResource by lazy {
      StringResource("string:settings_slot_start_hint", "settings_slot_start_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 307653, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 438977, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 281828, 52),
      ))
    }

@delegate:ResourceContentHash(1_836_511_278)
public val Res.string.settings_special_days: StringResource by lazy {
      StringResource("string:settings_special_days", "settings_special_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 308910, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 440782, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 283065, 53),
      ))
    }

@delegate:ResourceContentHash(-1_069_774_923)
public val Res.string.settings_special_days_hint: StringResource by lazy {
      StringResource("string:settings_special_days_hint", "settings_special_days_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 307710, 318),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 439046, 526),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 281881, 350),
      ))
    }

@delegate:ResourceContentHash(-2_054_595_498)
public val Res.string.settings_special_days_off: StringResource by lazy {
      StringResource("string:settings_special_days_off", "settings_special_days_off", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 308029, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 439573, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 282232, 37),
      ))
    }

@delegate:ResourceContentHash(399_103_638)
public val Res.string.settings_special_days_on: StringResource by lazy {
      StringResource("string:settings_special_days_on", "settings_special_days_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 308067, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 439615, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 282270, 36),
      ))
    }

@delegate:ResourceContentHash(398_748_314)
public val Res.string.settings_special_days_sources: StringResource by lazy {
      StringResource("string:settings_special_days_sources", "settings_special_days_sources", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 308104, 233),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 439656, 373),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 282307, 217),
      ))
    }

@delegate:ResourceContentHash(-1_467_124_600)
public val Res.string.settings_special_days_switch: StringResource by lazy {
      StringResource("string:settings_special_days_switch", "settings_special_days_switch", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 308338, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 440030, 128),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 282525, 84),
      ))
    }

@delegate:ResourceContentHash(4_452_414)
public val Res.string.settings_special_days_title: StringResource by lazy {
      StringResource("string:settings_special_days_title", "settings_special_days_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 308431, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 440159, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 282610, 79),
      ))
    }

@delegate:ResourceContentHash(250_411_666)
public val Res.string.settings_special_days_voivodeship: StringResource by lazy {
      StringResource("string:settings_special_days_voivodeship", "settings_special_days_voivodeship", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 308852, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 440712, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 283007, 57),
      ))
    }

@delegate:ResourceContentHash(-310_176_225)
public val Res.string.settings_special_days_voivodeship_auto: StringResource by lazy {
      StringResource("string:settings_special_days_voivodeship_auto", "settings_special_days_voivodeship_auto", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 308511, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 440259, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 282690, 70),
      ))
    }

@delegate:ResourceContentHash(-1_753_586_909)
public val Res.string.settings_special_days_voivodeship_found: StringResource by lazy {
      StringResource("string:settings_special_days_voivodeship_found", "settings_special_days_voivodeship_found", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 308578, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 440334, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 282761, 79),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString36Resources(map: MutableMap<String, StringResource>) {
  map.put("settings_no_show_off", Res.string.settings_no_show_off)
  map.put("settings_no_slots", Res.string.settings_no_slots)
  map.put("settings_none", Res.string.settings_none)
  map.put("settings_open_shift_cost", Res.string.settings_open_shift_cost)
  map.put("settings_open_shift_cost_automatic", Res.string.settings_open_shift_cost_automatic)
  map.put("settings_open_shift_cost_automatic_hint", Res.string.settings_open_shift_cost_automatic_hint)
  map.put("settings_open_shift_cost_fixed", Res.string.settings_open_shift_cost_fixed)
  map.put("settings_open_shift_cost_fixed_value", Res.string.settings_open_shift_cost_fixed_value)
  map.put("settings_open_shift_cost_hint", Res.string.settings_open_shift_cost_hint)
  map.put("settings_open_shift_cost_invalid", Res.string.settings_open_shift_cost_invalid)
  map.put("settings_open_shift_cost_rate", Res.string.settings_open_shift_cost_rate)
  map.put("settings_open_shift_cost_rate_optional", Res.string.settings_open_shift_cost_rate_optional)
  map.put("settings_owner_unpaid", Res.string.settings_owner_unpaid)
  map.put("settings_owner_unpaid_hint", Res.string.settings_owner_unpaid_hint)
  map.put("settings_payroll", Res.string.settings_payroll)
  map.put("settings_policy_a_desc", Res.string.settings_policy_a_desc)
  map.put("settings_policy_a_title", Res.string.settings_policy_a_title)
  map.put("settings_policy_b_desc", Res.string.settings_policy_b_desc)
  map.put("settings_policy_b_title", Res.string.settings_policy_b_title)
  map.put("settings_policy_c_desc", Res.string.settings_policy_c_desc)
  map.put("settings_policy_c_title", Res.string.settings_policy_c_title)
  map.put("settings_policy_d_desc", Res.string.settings_policy_d_desc)
  map.put("settings_policy_d_title", Res.string.settings_policy_d_title)
  map.put("settings_policy_updated", Res.string.settings_policy_updated)
  map.put("settings_remove_workspace", Res.string.settings_remove_workspace)
  map.put("settings_remove_workspace_confirm", Res.string.settings_remove_workspace_confirm)
  map.put("settings_reports_hint", Res.string.settings_reports_hint)
  map.put("settings_reports_title", Res.string.settings_reports_title)
  map.put("settings_request_types", Res.string.settings_request_types)
  map.put("settings_requests", Res.string.settings_requests)
  map.put("settings_requests_days", Res.string.settings_requests_days)
  map.put("settings_requests_hours", Res.string.settings_requests_hours)
  map.put("settings_rest_rules", Res.string.settings_rest_rules)
  map.put("settings_rest_rules_hint", Res.string.settings_rest_rules_hint)
  map.put("settings_rest_rules_off", Res.string.settings_rest_rules_off)
  map.put("settings_rest_rules_on", Res.string.settings_rest_rules_on)
  map.put("settings_rest_rules_switch", Res.string.settings_rest_rules_switch)
  map.put("settings_rest_rules_title", Res.string.settings_rest_rules_title)
  map.put("settings_role_hint", Res.string.settings_role_hint)
  map.put("settings_roles", Res.string.settings_roles)
  map.put("settings_roster_blueprint", Res.string.settings_roster_blueprint)
  map.put("settings_roster_blueprint_desc", Res.string.settings_roster_blueprint_desc)
  map.put("settings_roster_visibility", Res.string.settings_roster_visibility)
  map.put("settings_roster_visibility_full", Res.string.settings_roster_visibility_full)
  map.put("settings_roster_visibility_full_desc", Res.string.settings_roster_visibility_full_desc)
  map.put("settings_roster_visibility_hidden_people", Res.string.settings_roster_visibility_hidden_people)
  map.put("settings_roster_visibility_hint", Res.string.settings_roster_visibility_hint)
  map.put("settings_roster_visibility_own", Res.string.settings_roster_visibility_own)
  map.put("settings_roster_visibility_own_desc", Res.string.settings_roster_visibility_own_desc)
  map.put("settings_roster_visibility_title", Res.string.settings_roster_visibility_title)
  map.put("settings_roster_visibility_with_me", Res.string.settings_roster_visibility_with_me)
  map.put("settings_roster_visibility_with_me_desc", Res.string.settings_roster_visibility_with_me_desc)
  map.put("settings_sales_targets", Res.string.settings_sales_targets)
  map.put("settings_saved", Res.string.settings_saved)
  map.put("settings_section_alerts", Res.string.settings_section_alerts)
  map.put("settings_section_availability_slots", Res.string.settings_section_availability_slots)
  map.put("settings_section_breaks", Res.string.settings_section_breaks)
  map.put("settings_section_clock_review", Res.string.settings_section_clock_review)
  map.put("settings_section_footer", Res.string.settings_section_footer)
  map.put("settings_section_geofence", Res.string.settings_section_geofence)
  map.put("settings_section_income", Res.string.settings_section_income)
  map.put("settings_section_labour_targets", Res.string.settings_section_labour_targets)
  map.put("settings_section_payroll", Res.string.settings_section_payroll)
  map.put("settings_section_region", Res.string.settings_section_region)
  map.put("settings_section_reports", Res.string.settings_section_reports)
  map.put("settings_section_requests", Res.string.settings_section_requests)
  map.put("settings_section_rest_rules", Res.string.settings_section_rest_rules)
  map.put("settings_section_roles_skills", Res.string.settings_section_roles_skills)
  map.put("settings_section_roster_visibility", Res.string.settings_section_roster_visibility)
  map.put("settings_section_sales_targets", Res.string.settings_section_sales_targets)
  map.put("settings_section_special_days", Res.string.settings_section_special_days)
  map.put("settings_section_staff_checks", Res.string.settings_section_staff_checks)
  map.put("settings_section_sundays", Res.string.settings_section_sundays)
  map.put("settings_section_swap_policy", Res.string.settings_section_swap_policy)
  map.put("settings_section_templates", Res.string.settings_section_templates)
  map.put("settings_section_weather", Res.string.settings_section_weather)
  map.put("settings_section_work_hours", Res.string.settings_section_work_hours)
  map.put("settings_settlement_months_1", Res.string.settings_settlement_months_1)
  map.put("settings_settlement_months_2", Res.string.settings_settlement_months_2)
  map.put("settings_settlement_months_3", Res.string.settings_settlement_months_3)
  map.put("settings_settlement_months_4", Res.string.settings_settlement_months_4)
  map.put("settings_settlement_period", Res.string.settings_settlement_period)
  map.put("settings_settlement_period_hint", Res.string.settings_settlement_period_hint)
  map.put("settings_show_on_map", Res.string.settings_show_on_map)
  map.put("settings_skill_hint", Res.string.settings_skill_hint)
  map.put("settings_skills", Res.string.settings_skills)
  map.put("settings_slot_end_hint", Res.string.settings_slot_end_hint)
  map.put("settings_slot_label_hint", Res.string.settings_slot_label_hint)
  map.put("settings_slot_label_required", Res.string.settings_slot_label_required)
  map.put("settings_slot_start_hint", Res.string.settings_slot_start_hint)
  map.put("settings_special_days", Res.string.settings_special_days)
  map.put("settings_special_days_hint", Res.string.settings_special_days_hint)
  map.put("settings_special_days_off", Res.string.settings_special_days_off)
  map.put("settings_special_days_on", Res.string.settings_special_days_on)
  map.put("settings_special_days_sources", Res.string.settings_special_days_sources)
  map.put("settings_special_days_switch", Res.string.settings_special_days_switch)
  map.put("settings_special_days_title", Res.string.settings_special_days_title)
  map.put("settings_special_days_voivodeship", Res.string.settings_special_days_voivodeship)
  map.put("settings_special_days_voivodeship_auto", Res.string.settings_special_days_voivodeship_auto)
  map.put("settings_special_days_voivodeship_found", Res.string.settings_special_days_voivodeship_found)
}
